// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Kufi+Arabic:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mk-doc {
  --navy: #1a1d4f;
  --navy-2: #2b2f6e;
  --page: #f4f5fa;
  --line: #e4e6ef;
  --muted: #6b7086;
  --ink: #2e2306;
  --rule: rgba(70, 50, 10, 0.55);
  --cell: rgba(255, 250, 225, 0.38);
  padding: 24px 20px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  color: #1c1f2e;
  box-sizing: border-box;
}
.mk-doc *,
.mk-doc *::before,
.mk-doc *::after {
  box-sizing: border-box;
}
.mk-doc .ar {
  font-family: "Noto Kufi Arabic", Tahoma, sans-serif;
  direction: rtl;
}
.mk-doc-title {
  text-align: center;
}
.mk-doc-title .ar {
  font-size: 20px;
  font-weight: 700;
  color: #1c1f2e;
}
.mk-doc-title .en {
  font-size: 20px;
  font-weight: 600;
  color: #1c1f2e;
}
.mk-card {
  container-type: inline-size;
  width: 100%;
  max-width: 560px;
  aspect-ratio: 1.586;
  border-radius: 4.2cqw;
  position: relative;
  overflow: visible;
  color: var(--ink);
  background:
    radial-gradient(
      120% 90% at 15% 10%,
      rgba(255, 248, 210, 0.55),
      transparent 55%
    ),
    repeating-linear-gradient(
      115deg,
      rgba(255, 255, 255, 0.05) 0 2px,
      rgba(0, 0, 0, 0.025) 2px 4px
    ),
    linear-gradient(
      135deg,
      #c79b3f 0%,
      #e6c977 28%,
      #d3ad57 52%,
      #efd88f 74%,
      #c39437 100%
    );
  box-shadow:
    0 10px 28px rgba(80, 55, 10, 0.35),
    inset 0 0 0 1px rgba(255, 255, 255, 0.35);
  padding: 4.2cqw 4.6cqw 3.4cqw;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.mk-card .wm {
  position: absolute;
  left: 50%;
  top: 52%;
  width: 38cqw;
  transform: translate(-50%, -50%);
  opacity: 0.1;
  pointer-events: none;
  filter: sepia(1) saturate(0.6);
}
.mk-card > *:not(.wm) {
  position: relative;
}
.c-head {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  grid-gap: 2cqw;
  gap: 2cqw;
  margin-bottom: 2.2cqw;
}
.c-head .en {
  font-family: "Times New Roman", Times, serif;
  font-weight: 700;
  font-size: 3.1cqw;
  letter-spacing: 0.2px;
  line-height: 1.15;
}
.c-head .en small {
  display: block;
  font-family: "Times New Roman", Times, serif;
  font-weight: 400;
  font-size: 2.4cqw;
  color: #7a1414;
}
.c-head .ar {
  text-align: left;
  font-weight: 700;
  font-size: 3.2cqw;
  line-height: 1.3;
}
.c-head .ar small {
  display: block;
  font-weight: 600;
  font-size: 2.4cqw;
  color: #7a1414;
}
.c-head img {
  height: 10.5cqw;
  width: auto;
  display: block;
}
.c-sec {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 0 0 1.2cqw;
}
.c-sec .en {
  font-family: "Times New Roman", Times, serif;
  font-size: 2.9cqw;
}
.c-sec .ar {
  font-size: 3cqw;
  font-weight: 600;
}
.c-tbl {
  border: 1px solid var(--rule);
}
.r {
  display: grid;
  grid-template-columns: 19% 1fr 19%;
  border-bottom: 1px solid var(--rule);
  min-height: 4.6cqw;
}
.r:last-child {
  border-bottom: 0;
}
.r.pair {
  grid-template-columns: 19% 1fr 17% 1fr 19%;
}
.r > div {
  display: flex;
  align-items: center;
  padding: 0.35cqw 1cqw;
  min-width: 0;
}
.l {
  font-family: "Times New Roman", Times, serif;
  font-size: max(8px, 2.25cqw);
  line-height: 1.1;
  border-right: 1px solid var(--rule);
}
.la {
  font-size: max(8px, 2.1cqw);
  justify-content: flex-start;
  border-left: 1px solid var(--rule);
}
.v {
  background: var(--cell);
  font-weight: 700;
  font-size: max(9px, 2.35cqw);
  letter-spacing: 0.2px;
  text-transform: uppercase;
  justify-content: center;
  text-align: center;
  gap: 1.6cqw;
  flex-wrap: wrap;
  word-break: break-word;
}
.v .ar {
  text-transform: none;
  font-weight: 700;
}
.v.mono {
  font-family: ui-monospace, Menlo, Consolas, monospace;
  letter-spacing: 0.6px;
}
.m {
  flex-direction: column;
  align-items: stretch !important;
  justify-content: center;
  border-left: 1px solid var(--rule);
  border-right: 1px solid var(--rule);
  gap: 0.2cqw;
}
.m .ar {
  font-size: max(7px, 1.8cqw);
  text-align: right;
}
.m .en {
  font-family: "Times New Roman", Times, serif;
  font-size: max(7px, 1.9cqw);
  text-align: left;
}
.c-foot {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 2cqw;
  margin-top: 1.8cqw;
}
.c-foot .note {
  font-size: max(7px, 1.75cqw);
  font-weight: 600;
  line-height: 1.35;
}
.c-foot .brand {
  font-weight: 700;
  font-size: max(9px, 2.6cqw);
  letter-spacing: 0.3px;
}
.c-foot .stamp {
  font-family: "Times New Roman", Times, serif;
  font-weight: 700;
  font-size: 4.6cqw;
  letter-spacing: 0.6cqw;
  opacity: 0.28;
  line-height: 1;
}
.status {
  display: inline-block;
  font-family: Inter, sans-serif;
  font-size: max(8px, 1.9cqw);
  font-weight: 700;
  padding: 0.4cqw 1.4cqw;
  border-radius: 99px;
  text-transform: none;
  letter-spacing: 0;
}
.status.ok {
  background: #1f7a46;
  color: #fff;
}
.status.warn {
  background: #a86512;
  color: #fff;
}
.status.bad {
  background: #a32020;
  color: #fff;
}
.status.na {
  background: rgba(0, 0, 0, 0.18);
  color: #fff;
}
.mk-src {
  font-size: 12px;
  color: var(--muted);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Vehicle/mulkiya.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,iCAAiC;EACjC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,4EAA4E;EAC5E,cAAc;EACd,sBAAsB;AACxB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,mDAAmD;EACnD,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB;;;;;;;;;;;;;;;;;;KAkBG;EACH;;6CAE2C;EAC3C,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,cAAS;EAAT,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,4CAA4C;EAC5C,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Noto+Kufi+Arabic:wght@400;600;700&display=swap\");\n\n.mk-doc {\n  --navy: #1a1d4f;\n  --navy-2: #2b2f6e;\n  --page: #f4f5fa;\n  --line: #e4e6ef;\n  --muted: #6b7086;\n  --ink: #2e2306;\n  --rule: rgba(70, 50, 10, 0.55);\n  --cell: rgba(255, 250, 225, 0.38);\n  padding: 24px 20px 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 22px;\n  font-family: Inter, system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  color: #1c1f2e;\n  box-sizing: border-box;\n}\n.mk-doc *,\n.mk-doc *::before,\n.mk-doc *::after {\n  box-sizing: border-box;\n}\n.mk-doc .ar {\n  font-family: \"Noto Kufi Arabic\", Tahoma, sans-serif;\n  direction: rtl;\n}\n.mk-doc-title {\n  text-align: center;\n}\n.mk-doc-title .ar {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1c1f2e;\n}\n.mk-doc-title .en {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1c1f2e;\n}\n.mk-card {\n  container-type: inline-size;\n  width: 100%;\n  max-width: 560px;\n  aspect-ratio: 1.586;\n  border-radius: 4.2cqw;\n  position: relative;\n  overflow: visible;\n  color: var(--ink);\n  background:\n    radial-gradient(\n      120% 90% at 15% 10%,\n      rgba(255, 248, 210, 0.55),\n      transparent 55%\n    ),\n    repeating-linear-gradient(\n      115deg,\n      rgba(255, 255, 255, 0.05) 0 2px,\n      rgba(0, 0, 0, 0.025) 2px 4px\n    ),\n    linear-gradient(\n      135deg,\n      #c79b3f 0%,\n      #e6c977 28%,\n      #d3ad57 52%,\n      #efd88f 74%,\n      #c39437 100%\n    );\n  box-shadow:\n    0 10px 28px rgba(80, 55, 10, 0.35),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.35);\n  padding: 4.2cqw 4.6cqw 3.4cqw;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.mk-card .wm {\n  position: absolute;\n  left: 50%;\n  top: 52%;\n  width: 38cqw;\n  transform: translate(-50%, -50%);\n  opacity: 0.1;\n  pointer-events: none;\n  filter: sepia(1) saturate(0.6);\n}\n.mk-card > *:not(.wm) {\n  position: relative;\n}\n.c-head {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 2cqw;\n  margin-bottom: 2.2cqw;\n}\n.c-head .en {\n  font-family: \"Times New Roman\", Times, serif;\n  font-weight: 700;\n  font-size: 3.1cqw;\n  letter-spacing: 0.2px;\n  line-height: 1.15;\n}\n.c-head .en small {\n  display: block;\n  font-family: \"Times New Roman\", Times, serif;\n  font-weight: 400;\n  font-size: 2.4cqw;\n  color: #7a1414;\n}\n.c-head .ar {\n  text-align: left;\n  font-weight: 700;\n  font-size: 3.2cqw;\n  line-height: 1.3;\n}\n.c-head .ar small {\n  display: block;\n  font-weight: 600;\n  font-size: 2.4cqw;\n  color: #7a1414;\n}\n.c-head img {\n  height: 10.5cqw;\n  width: auto;\n  display: block;\n}\n.c-sec {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin: 0 0 1.2cqw;\n}\n.c-sec .en {\n  font-family: \"Times New Roman\", Times, serif;\n  font-size: 2.9cqw;\n}\n.c-sec .ar {\n  font-size: 3cqw;\n  font-weight: 600;\n}\n.c-tbl {\n  border: 1px solid var(--rule);\n}\n.r {\n  display: grid;\n  grid-template-columns: 19% 1fr 19%;\n  border-bottom: 1px solid var(--rule);\n  min-height: 4.6cqw;\n}\n.r:last-child {\n  border-bottom: 0;\n}\n.r.pair {\n  grid-template-columns: 19% 1fr 17% 1fr 19%;\n}\n.r > div {\n  display: flex;\n  align-items: center;\n  padding: 0.35cqw 1cqw;\n  min-width: 0;\n}\n.l {\n  font-family: \"Times New Roman\", Times, serif;\n  font-size: max(8px, 2.25cqw);\n  line-height: 1.1;\n  border-right: 1px solid var(--rule);\n}\n.la {\n  font-size: max(8px, 2.1cqw);\n  justify-content: flex-start;\n  border-left: 1px solid var(--rule);\n}\n.v {\n  background: var(--cell);\n  font-weight: 700;\n  font-size: max(9px, 2.35cqw);\n  letter-spacing: 0.2px;\n  text-transform: uppercase;\n  justify-content: center;\n  text-align: center;\n  gap: 1.6cqw;\n  flex-wrap: wrap;\n  word-break: break-word;\n}\n.v .ar {\n  text-transform: none;\n  font-weight: 700;\n}\n.v.mono {\n  font-family: ui-monospace, Menlo, Consolas, monospace;\n  letter-spacing: 0.6px;\n}\n.m {\n  flex-direction: column;\n  align-items: stretch !important;\n  justify-content: center;\n  border-left: 1px solid var(--rule);\n  border-right: 1px solid var(--rule);\n  gap: 0.2cqw;\n}\n.m .ar {\n  font-size: max(7px, 1.8cqw);\n  text-align: right;\n}\n.m .en {\n  font-family: \"Times New Roman\", Times, serif;\n  font-size: max(7px, 1.9cqw);\n  text-align: left;\n}\n.c-foot {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 2cqw;\n  margin-top: 1.8cqw;\n}\n.c-foot .note {\n  font-size: max(7px, 1.75cqw);\n  font-weight: 600;\n  line-height: 1.35;\n}\n.c-foot .brand {\n  font-weight: 700;\n  font-size: max(9px, 2.6cqw);\n  letter-spacing: 0.3px;\n}\n.c-foot .stamp {\n  font-family: \"Times New Roman\", Times, serif;\n  font-weight: 700;\n  font-size: 4.6cqw;\n  letter-spacing: 0.6cqw;\n  opacity: 0.28;\n  line-height: 1;\n}\n.status {\n  display: inline-block;\n  font-family: Inter, sans-serif;\n  font-size: max(8px, 1.9cqw);\n  font-weight: 700;\n  padding: 0.4cqw 1.4cqw;\n  border-radius: 99px;\n  text-transform: none;\n  letter-spacing: 0;\n}\n.status.ok {\n  background: #1f7a46;\n  color: #fff;\n}\n.status.warn {\n  background: #a86512;\n  color: #fff;\n}\n.status.bad {\n  background: #a32020;\n  color: #fff;\n}\n.status.na {\n  background: rgba(0, 0, 0, 0.18);\n  color: #fff;\n}\n.mk-src {\n  font-size: 12px;\n  color: var(--muted);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
